'use-strict';

import io from 'socket.io-client';

/* @ngInject */
export class SocketService {
  constructor($rootScope, $location, usersService, browserStatisticsService) {
    'ngInject';

    this.$rootScope = $rootScope;
    this.$location = $location;
    this.usersService = usersService;
    this.browserStatisticsService = browserStatisticsService;

    console.log(WEBSOCKET_URL);

    this.socket = io.connect(WEBSOCKET_URL, {
      secure: true,
    });
    this.registerListeners();
  }

  init() {}

  /**
   * Register this client at the API server.
   */
  registerClient() {
    const userId = this.usersService.currentUserId();
    const tenantId = this.$rootScope.TENANT_ID;

    this.emit('register', {
      userId,
      tenantId,
      deviceId: this.browserStatisticsService.getDeviceId(),
    });

    console.info('%c[SOCKET]: Registered at server.', 'background:#353830;color:#8BC94B');
  }

  on(eventName, callback) {
    // this.socket.removeAllListeners(eventName);
    console.info('Register websocket listener for ', eventName);
    this.socket.on(eventName, (data) => {
      callback(data);
      // callback(JSON.parse(data));
    });
  }

  emit(eventName, data, callback) {
    const self = this;

    self.socket.emit(eventName, data, function () {
      const args = arguments;

      self.$rootScope.$apply(() => {
        if (callback) {
          callback.apply(self.socket, args);
        }
      });
    });
  }

  registerListeners() {
    /**
     * SOCKET COMMUNICATION
     */
    this.on('connect', () => {
      console.info('%c[SOCKET]: Connection established.', 'background:#353830;color:#8BC94B');
      this.registerClient();
    });

    this.on('connect_timeout', () => {
      console.info('%c[SOCKET]: Connection Timeout!', 'background:#353830;color:#8BC94B');
    });

    this.on('connect_error', () => {
      console.info('%c[SOCKET]: Connection Error!', 'background:#353830;color:#8BC94B');
    });

    this.on('reconnecting', () => {
      console.info('%c[SOCKET]: Reconnecting!', 'background:#353830;color:#8BC94B');
    });

    this.on('reconnect', () => {
      console.info('%c[SOCKET]: Reconnected!', 'background:#353830;color:#8BC94B');
      this.registerClient();
    });
  }
}

export default angular.module('services.socketService', [])
  .service('socketService', SocketService)
  .name;
